import crudlModuleGenerator from '@/_CRUDL/modules/generator';

const multiple = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/leads`;
const single = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/leads/:cpf_cnpj`;

export default crudlModuleGenerator('leads', {
  customKeys: {
    create: 'data',
    read: 'data',
    update: 'data',
    delete: 'data',
    list: 'data',
  },
  customEndpoints: {
    create: multiple,
    read: single,
    update: single,
    delete: single,
    list: multiple,
  },
});
